import $ from 'jquery'
export { goalbookUrls, pathwaysUrls, toolkitUrls, urlHelpers }

const dnsName = process.env.VUE_APP_DNS_NAME || 'goalbookapp.com';

var goalbookUrls = {}

goalbookUrls.toolkit = process.env.VUE_APP_TOOLKIT_URL
goalbookUrls.pathways = process.env.VUE_APP_PATHWAYS_URL
goalbookUrls.pathwaysApi = `${goalbookUrls.pathways}/api/v1`
goalbookUrls.presentlevels = process.env.VUE_APP_PRESENTLEVELS_URL
goalbookUrls.accounts = process.env.VUE_APP_ACCOUNTS_URL
goalbookUrls.auth = process.env.VUE_APP_AUTH_URL
goalbookUrls.signUp = `${goalbookUrls.accounts}/users/sign_up`
goalbookUrls.signIn = `${goalbookUrls.accounts}/users/sign_in`
goalbookUrls.signOut = `${goalbookUrls.toolkit}/sign_out`
goalbookUrls.forgotPassword = `${goalbookUrls.accounts}/users/password/new`
goalbookUrls.collections = process.env.VUE_APP_COLLECTIONS_URL
goalbookUrls.collectionsApi = goalbookUrls.collections + '/collections/api/v1'
goalbookUrls.lms = process.env.VUE_APP_LMS_URL
goalbookUrls.aboutUDL = 'https://www.cast.org/what-we-do/universal-design-for-learning/'
goalbookUrls.growGoalLink = function(folderUuid, goalUuid) { return  `${process.env.VUE_APP_GROW_URL}/manage?folder=${folderUuid}&goal=${goalUuid}` }
goalbookUrls.threads = process.env.VUE_APP_THREADS_URL

var toolkitUrls = {
  home: goalbookUrls.toolkit,
  api: `${goalbookUrls.toolkit}/api`,
  contentProfilesEndpoint: `${goalbookUrls.toolkit}/content_profile`,
  browse: `${goalbookUrls.toolkit}/browse`,
  browseUrlForCriteria(subject, grades, subjectDomains, standards, keywords) {
    // /browse#?keywords=asdf%20asdf&grades=3,4,10&subjects=Reading&subject_domains=Fluency&standards=CCSS.ELA-Literacy.RF.4.4
    let params = {}
    if (subject) {
      params.subjects = subject
    }
    if (grades) {
      params.grades = grades.join(',')
    }
    if (subjectDomains) {
      params.subject_domains = subjectDomains[0]
    }
    if (standards) {
      params.standards = standards[0]
    }
    return `${goalbookUrls.toolkit}/browse#?${$.param(params)}`
  },

  libraryStrategyPage(id) {
    return `${goalbookUrls.toolkit}/library/strategy/${id}`
  },
  libraryGoalPage(id) {
    return {
      name: 'SavedGoalContentPage',
      params: {
        uuid: id,
      },
    }
  },
  mediumPosts: `${goalbookUrls.toolkit}/medium/posts`,
  toolkitUpdates: 'https://goalbook.com/category/innovation/',
  upcomingWebinars: `${goalbookUrls.toolkit}/webinars/upcoming`,
  share: `${goalbookUrls.toolkit}/share`,
  subscribe: `https://${dnsName}/explore-toolkit/#get-started`,
  subscribeUniversity: `${goalbookUrls.toolkit}/subscribe/university`,
  library: `${goalbookUrls.toolkit}/library`,
  libraryAllFolders: `${goalbookUrls.toolkit}/v/library/all`,
  libraryRecentlySaved: `${goalbookUrls.toolkit}/v/library/recently_saved`,
  libraryFolder(id, beta=false) {
    let url = `${goalbookUrls.toolkit}/v/folder/${id}`
    if (beta) {
      url += '?beta=true'
    }
    return url
  },
  savedIOD(id, beta=false) {
    let url = `${goalbookUrls.toolkit}/v/library/iod/${id}`
    if (beta) {
      url += '?beta=true'
    }
    return url
  },
  presentlevels: {
    v2: `${goalbookUrls.toolkit}/v/presentlevels/v2/session`,
  },
  account: `${goalbookUrls.toolkit}/account`,
  userList: `${goalbookUrls.toolkit}/admin`,
  webinars: `https://sites.google.com/${dnsName}/toolkitwebinars/home`,
  pastWebinars: `https://sites.google.com/${dnsName}/toolkitwebinars/past-webinars`,
  mediumBlog: 'https://goalbook.com/thought-leadership/',
  editorLinks: {
    editGoal(id) {
      return `${goalbookUrls.toolkit}/edit/goal/${id}`
    },
    editStrategy(id) {
      return `${goalbookUrls.toolkit}/edit/strategy/${id}`
    },
    editStandard(id) {
      return `${goalbookUrls.toolkit}/edit/standard/${id}`
    },
    strategiesAdmin: `${goalbookUrls.toolkit}/strategies/list`,
    goalsAdmin: `${goalbookUrls.toolkit}/filter`,
    researchCitations: `${goalbookUrls.toolkit}/research/list`,
    myGoals(authorId) {
      return `${goalbookUrls.toolkit}/filter/#?author_id=${authorId}`
    },
    prekStandards: `${goalbookUrls.pathways}/v/admin/standards/NY-PreK`,
    widaStandards: `${goalbookUrls.toolkit}/standards/wida`,
    caEldStandards: `${goalbookUrls.pathways}/v/admin/standards/CA-ELD`,
    ilsSelStandards: `${goalbookUrls.pathways}/v/admin/standards/ILS-SEL`,
    dlmStandards: `${goalbookUrls.pathways}/v/admin/standards/DLM-EE`,
    ncscStandards: `${goalbookUrls.toolkit}/standards/ncsc-ccc`,
    coachStandards: `${goalbookUrls.pathways}/v/admin/standards/COACH`,
    teksStandards: `${goalbookUrls.pathways}/v/admin/standards/TEKS`,
    teks2017Standards: `${goalbookUrls.pathways}/v/admin/standards/TEKS-2017`,
    udlStandards: `${goalbookUrls.toolkit}/standards/udl`,
    allStandards: `${goalbookUrls.pathways}/v/admin/standards`,
    addGoal: `${goalbookUrls.toolkit}/add/goal`,
    addStrategy: `${goalbookUrls.toolkit}/add/strategy`,
    addResearchCitation: `${goalbookUrls.toolkit}/add/research`,
  },
  homepageAssets: {
    strategiesImg: 'https://assets.goalbookapp.com/images/strategies_image.svg',
    goalsImg: 'https://assets.goalbookapp.com/images/goals_image.svg',
    presentLevelsImg: 'https://assets.goalbookapp.com/images/presentlevels_image.svg',
  },
}

var pathwaysUrls = {
  home: goalbookUrls.pathways,
  resourceDetail(id) {
    return `${goalbookUrls.pathways}/#!/resources/${id}`
  },
  editItem(id) {
    return `${goalbookUrls.pathways}/#!/items/${id}/edit`
  },
  itemDetail(id) {
    return `${goalbookUrls.pathways}/#!/items/${id}`
  },
  editStandard(setCode, standardRef) {
    return `${goalbookUrls.pathways}/#!/admin/standards/${setCode}/${standardRef}`
  },
  translateGoalText: `${goalbookUrls.pathwaysApi}/translation_generation/translate`
}

var urlHelpers = {
  originAndBase: `${window.location.protocol}//${window.location.host}${process.env.VUE_APP_ROUTER_BASE}`,
  signInReturn(returnUrl) {
    let returnUrlFragment = ''
    if (returnUrl) returnUrlFragment = `?return_url=${encodeURIComponent(returnUrl)}`
    return `${goalbookUrls.signIn}${returnUrlFragment}`
  },
  signUpReturn(product = 'toolkit', returnUrl) {
    let returnUrlFragment = ''
    if (returnUrl) returnUrlFragment = `?return_url=${encodeURIComponent(returnUrl)}`
    return `${goalbookUrls.signUp}/${product}${returnUrlFragment}`
  }
}
